import * as React from 'react';
import WebSocketService from 'services/WebsocketService';
const WebSocketContext = React.createContext(new WebSocketService(undefined, undefined));
export default WebSocketContext;
